"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  abf: 'abf',
  about: 'om-os',
  aboutOrganisation: 'om-foreningen',
  accounting: 'regnskabsindstillinger',
  accounts: 'kontoplan',
  admin: 'admin',
  appPrefix: '/app',
  association: 'forening',
  balancingAccount: 'afstemning',
  blog: 'artikler',
  board: 'bestyrelse',
  bookkeeping: 'bogfoering',
  editCharges: 'rediger-opkravninger',
  charges: 'opkravning',
  chargesNext: 'kommende',
  chargesOverView: 'opkraevninger',
  chargesPrevious: 'tidligere',
  createCharge: 'createCharge',
  createResident: 'createResident',
  createUnit: 'createUnit',
  customerBalance: 'customerBalance',
  document: 'dokument',
  documents: 'dokumenter',
  editCharge: 'editCharge',
  editResident: 'editResident',
  editUnit: 'editUnit',
  endOfYear: 'aarsafslutning2024',
  approvals: 'godkendelser',
  expenses: 'regninger',
  financialBalance: 'balance',
  financialReport: 'regnskab',
  financialReportSettings: 'finansIndstillinger',
  financialReportYear: 'regnskabsaar',
  financialResult: 'resultat',
  info: 'ejendom',
  loadUnits: 'upload-enheder',
  manual: 'manuel',
  meetings: 'moeder',
  messages: 'beskeder',
  tasks: 'opgaver',
  missingId: 'upload-id',
  myprofile: 'minprofil',
  masterData: 'stamdata',
  organizations: 'foreninger',
  owners: 'ejere',
  offer: 'indhent-tilbud',
  passkey: 'passkey',
  payments: 'opkraevninger',
  prices: 'priser-ejendomsadministration',
  products: 'produkter',
  residents: 'beboere',
  sublets: 'fremlejere',
  services: 'ydelser-ejendomsadministration',
  settings: 'indstillinger',
  signature: 'signatur',
  superAdmin: 'superAdmin',
  suppliers: 'leverandoerer',
  questionnaire: 'sporgeskema',
  agreements: 'aktive-bsplus-aftaler',
  team: 'dabea-teamet',
  banking: 'bank',
  transactions: 'transaktioner',
  unit: 'enhed',
  units: 'enheder',
  users: 'brugere',
  voucherTemplates: 'skabeloner'
};